import { Link } from "react-router";
import { useI18n } from "../i18n/I18nProvider";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="container section status">
      <h1>{t("notFound.title")}</h1>
      <Link to="/" className="btn btn-primary">
        {t("notFound.back")}
      </Link>
    </div>
  );
}
